function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { GLUCOSE_LEVELS_COLORS, CHART_ELEMENTS_COLORS } from 'modules/App/constants';
export const MAX_VALUE = 350;
export const CGM_GOALS = {
    high: '<25%',
    target: '>70%',
    low: '<4%'
};
export const COLORS = _object_spread_props(_object_spread({}, GLUCOSE_LEVELS_COLORS, CHART_ELEMENTS_COLORS), {
    plain: '#30A8FF'
});
export const TREND_CHART_MARGIN = {
    top: 20,
    right: 50,
    bottom: 50,
    left: 50
};
export const TREND_CHART_BASE_THEME = {
    crosshair: {
        line: {
            stroke: '#30A8FF',
            strokeWidth: 1,
            strokeDasharray: null
        }
    },
    axis: {
        ticks: {
            line: {
                stroke: COLORS.placeholder,
                strokeWidth: 1
            }
        }
    }
};
export const TREND_CHART_LOADER_THEME = {
    textColor: COLORS.placeholder,
    axis: {
        ticks: {
            line: {
                stroke: COLORS.placeholder,
                strokeWidth: 1
            },
            text: {}
        }
    },
    grid: {
        line: {
            stroke: COLORS.placeholder,
            strokeWidth: 1
        }
    }
};
export const TREND_CHART_DISTANCE = 7.5;
export const TREND_CHART_HOUR_RANGE = 2;
export const TREND_CHART_MIN_RANGE = TREND_CHART_HOUR_RANGE * 3600;
export const TREND_CHART_MAX_RANGES = 6;
export const RELATED_DATA_CHART_OPTIONS = [
    'activities',
    'medications',
    'carbs',
    'weight',
    'height'
];
